module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Chapitre deux")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("LE")]), _vm._v(" téléphone sonna et Matt répondit à l’appel alors qu’il descendait les escaliers pour voir quel était le problème avec la plomberie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bonsoir, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline Estates")]), _vm._v(". Puis-je vous aider ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Que Dieu l’aide, mais Belinda était en congé de maternité pendant les rénovations et bien que le moment ait été bien choisi, il n’avait pas réalisé le nombre d’appels téléphoniques qu’il recevrait par jour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’aimerais faire une réservation pour décembre, s’il vous plaît.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr, monsieur. Donnez-moi une seconde pour accéder à cet écran.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Merci à Dieu pour les tablettes, le WI-FI et les systèmes de vente. Il prit la réservation tout en observant un des petits sous-traitants et envoyant un texto à Neville, l’entrepreneur général, le tout en même temps.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Combien de personnes ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’homme réserva deux chambres dans la tour est qui était presque terminée. Le téléphone du sous-traitant sonna et Matt entendit Neville crier lorsque l’homme répondit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Réglez cela, ordonna-t-il avant de se diriger vers Jeannette afin de s’assurer que les nouvelles installations de la lingerie et de la buanderie étaient fonctionnelles. Son téléphone sonna encore une fois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline Estates")]), _vm._v(", puis-je vous aider ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est Geoff, patron. Quelqu’un remonte l’allée dans une limousine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous n’avons pas de clients, Geoff. Ils doivent être perdus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela n’en a pas l’air. Un chauffeur professionnel. Un gars du coin. Un VIP, quelque chose, d’après l’apparence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh, for…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Paix. Paix et calme. Paix, calme et zen. Paix, calme, zen et un énorme marteau.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Fais-les patienter, je vais vérifier les registres.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il vérifia les réservations, mais il était à zéro occupation. D’accord. Très bien. Il appela ensuite Jeannette.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bonjour, madame. Y a-t-il une suite VIP qui peut être préparée au cas où quelqu’un aurait réservé une chambre ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, monsieur. La Présidente est toujours en cours de peinture, mais la suite Patrick est prête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Excellent. Pouvez-vous appeler Dev et l’avertir qu’il est possible qu’il doive nourrir un invité en suite, ce soir ? J’en saurai plus dans dix minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je le fais tout de suite, assura-t-elle avant de raccrocher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Matt inspira à nouveau profondément, sentant la peinture qui était à l’ordre du jour depuis que la journée avait commencé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neville appela pendant qu’il se rendait en joggant à l’étage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’était facile à gérer. Il fera ça en moins de vingt minutes, pas de soucis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je l’espère bien, Nev. J’ai un client VIP qui vient d’arriver. Je n’ai pas besoin de cette merde.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neville et lui se comprenaient. Ils étaient tous les deux des Texans transplantés.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous avez ma parole. Je pensais que vous étiez vide, vous savez ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Moi aussi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Un autre appel arriva.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois raccrocher, Nev, dit Matt. Geoff ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il dit qu’il est le nouveau propriétaire, patron. Genre, pour de vrai. Qu’il est monsieur Patrick.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Matt s’arrêta, manquant de tomber sur le cul.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quoi ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peut-être quelques années de plus que vous, Blond. Yeux bleus. Cullen Patrick, Park City, Utah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— D’accord. D’accord. Euh…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Merde, merde, merde.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Que le chauffeur reste. Conduisez monsieur Patrick au salon, j’arrive tout de suite, reprit-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Après avoir tué quelqu’un")]), _vm._v(". Il appela monsieur Rollins, avocat, grommelant lorsque Jody répondit au téléphone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est Matt Nathanson. Passez-moi Rollins. Tout de suite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, monsieur. Bien sûr.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le fait qu’elle a immédiatement accepté fit sonner son alarme interne « tu as été baisé » et il travaillait dans l’hôtellerie. Elle était réglée sur une sensibilité incroyablement faible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Matt. Comment cela se passe ? dit Rollins de sa faible voix de vieillard.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Toujours un mauvais signe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ne faites pas ça. Qui vient de se présenter dans le hall en disant qu’il est le nouveau propriétaire et pourquoi n’ai-je reçu aucun avertissement ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("C’était déjà assez mauvais que la famille de Ben l’ait abandonné et ait laissé des étrangers s’occuper de lui et l’aimer, mais maintenant ceci ? Brusquement, il avait de l’argent et il avait un nouveau patron ? Ce n’était pas censé être ainsi. Il ne voulait pas de l’argent de Ben. Il voulait le "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline")]), _vm._v(". Il avait donné sa vie à Ben et à cet endroit pendant plus d’une décennie. Il avait mérité sa place ici.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Matt, s’il vous plaît. Je n’ai pas eu le temps d’appeler. Il vient de quitter mon bureau et j’ai eu une conférence téléphonique juste après. Je ne savais pas qu’on avait retrouvé le petit-fils de Ben jusqu’à ce qu’il arrive aujourd’hui. Un partenaire junior s’occupait des démarches.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Matt s’arrêta sur le palier, se laissa tomber sur le cul et ferma les yeux. Ce n’était pas une blague. Ce n’était pas un mensonge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais monter à l’étage et faire mes bagages. Souhaitez bonne chance au nouveau avec Nev.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Matt espérait que Nev baiserait le nouveau et le laisserait fauché et aveugle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh, arrêtez d’être mélodramatique, Matthew. Le fond en fidéicommis "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline")]), _vm._v(" s’occupe très bien de vous et de votre poste. Vous saviez que cela pourrait arriver. Bougez-vous et battez-vous pour votre maison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ma maison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Non, ce n’était pas la sienne. Il avait pensé que ça le serait, mais ce n’était pas le cas. Il était un employé. Simplement un autre gérant d’hôtel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, c’est votre maison. J’ai essayé de convaincre Ben de changer son testament, Matt. Il était trop tard lorsqu’il a finalement décidé de le faire. Nous avions rendez-vous le lendemain de sa mort. Je ne devrais peut-être pas vous le dire, mais vous devez savoir. Il voulait que vous ayez l’hôtel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est génial. Je suis ravi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Peu importe. Merde, il voulait s’allonger et mourir. Il avait cru… Bon sang, il avait vraiment cru pendant quelques semaines que ce rêve utopique était réel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— N’abandonnez pas, Matt. Promettez-moi d’attendre un peu avant de prendre une décision.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Son téléphone bipa, encore un autre appel entrant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois y aller, quelqu’un appelle, dit-il avant de raccrocher et de prendre l’autre appel. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline Estates")]), _vm._v(", comment puis-je vous aider ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai besoin de vous, patron, dit Geoff, appelant encore une fois, cette fois d’un portable. Il veut vous voir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’arrive. Il peut foutrement attendre jusqu’à ce que je sois là.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ne travaillait pas pour ce fils de pute. L’homme pouvait poireauter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— D’accord, répondit Geoff, semblant décontenancé")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pourquoi ne le serait-il pas ? Matt se démenait pour aider n’importe quel client.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je serai là dans cinq minutes, d’accord ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il raccrocha, puis laissa tomber sa tête dans ses mains"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(". Le calme. Le calme et le zen et une fichue grosse pierre.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se décida finalement à descendre, s’armant d’acier pour rencontrer le petit-fils de Ben qui n’avait jamais rencontré le vieil homme. Pas une seule fois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ne travaillait pas pour cet homme. Il ne répondrait pas à ce fils de pute. Il n’en avait rien à faire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bon sang, il n’en avait rien à faire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’homme qui l’attendait à la réception ressemblait à un skieur croisé avec… Matt aurait voulu dire un « hispter d’Austin », mais Geoff avait dit qu’il venait de l’Utah. Un jean, des bottes, un sweat-shirt Jeep Naked et des cheveux dorés hirsutes longs juste en dessous de son menton.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Monsieur Patrick ? Je suis monsieur Nathanson. Enchanté de vous rencontrer, dit-il en affichant son meilleur visage « hé, tu es un abruti et je dois m’occuper de toi ».")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bonjour, répondit Patrick en lui tendant la main. Cullen. J’espérais pouvoir rester quelques jours malgré la rénovation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous ne sommes pas vraiment ouverts en ce moment, j’en ai peur. Encore six semaines, au plus, avant qu’on commence à accepter des clients.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Espèce d’abruti")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Geoff m’a dit que la suite Patrick était prête. Mon homonyme, dit Cullen Patrick en lui souriant, l’air joyeux, mais ses yeux bleus étaient vigilants, tout comme ceux de Ben l’avaient été.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— De toute évidence, le voiturier est au courant de ce qui se passe, dit-il en jetant un coup d’œil à Geoff.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Et il était viré.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Geoff soupira, les épaules affaissées, réagissant clairement à son humeur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hé, je ne veux pas être un problème. Mon grand-père avait peut-être un appartement. Je pourrais y habiter. C’est juste un long chemin depuis Basalt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non. Je vais faire vérifier la chambre et quelqu’un viendra vous chercher. Asseyez-vous. Geoff, peux-tu aller chercher les bagages de monsieur Patrick ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, monsieur, répondit Geoff en sautant sur ses pieds.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis sûr que vous êtes très occupé, mais je pourrais peut-être vous parler autour d’un repas ou autre chose ? demanda Cullen. Je voulais discuter avec vous des termes du testament et de l’hôtel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tant mieux, il était impatient.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais parler au chef et lui demander d’arranger quelque chose, ajouta Matt. Le restaurant n’est pas ouvert, bien sûr, mais si vous me faites part de vos préférences…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh, je peux manger n’importe quoi de protéiné. J’adore les omelettes et tout ça. Des hamburgers à la dinde. Le poisson me va aussi. Si je ne m’entraînais pas autant pour le grand prix, je supplierais pour un hamburger au bœuf. L’avocat ne m’a pas dit grand-chose, alors je parie qu’il ne vous a pas dit que je venais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— En effet. On pourrait même dire que nous ne savions pas que vous existiez.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le téléphone sonna et il sauta dessus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Si vous voulez bien m’excuser. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Treeline Estates")]), _vm._v(", comment puis-je vous aider ? Non, je suis désolé, nous sommes déjà complets pour les vacances. J’ai une liste d’attente, si vous le souhaitez ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il envoya un texto à Devlin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("VIP, protéines, repas dans la chambre")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tout ce qu’il avait à faire, c’était travailler à présent. Il pourrait réfléchir et avoir une attaque… et virer Geoff… plus tard.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("APRÈS")]), _vm._v(" avoir passé une heure ou deux à se reposer, Cullen sortit"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("explorer son hôtel. Parce qu’il était à lui, bon sang, et qu’il n’avait pas à se sentir comme un client, n’est-ce pas ? Oh, il n’avait aucune envie de donner des ordres aux gens, mais il était plutôt… irrité par le fait que Nathanson, le directeur, l’ait sommairement congédié.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’homme était jeune, grand et sombre, avec un air coincé. Pas étonnant que son grand-père l’ait apprécié. Un costume-cravate en engraissant un autre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le hall d’entrée avait plutôt une bonne allure. Peinture fraîche. Canapés massifs nouvellement retapissés. Les peintures avaient été nettoyées, ce qu’il savait grâce à un cours en histoire de l’art de courte durée qu’il avait suivi en raison des incroyables fellations de Hayden qui suivait un cursus dans cette matière.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mais une fois le hall d’entrée dépassé, cependant ? Bon sang, c’était dur. L’endroit était assez propre, mais, merde, tout était usé. Le tapis de l’escalier principal, par exemple, était patiné, le vert s’estompait et les motifs floraux étaient ternes. Il y avait eu une fuite dans le couloir du deuxième étage, mal réparée et jaunissant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tout l’endroit semblait avoir été lavé une fois de trop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cullen jeta un coup d’œil dans quelques vitrines dans le couloir. Tous ses ancêtres étaient alignés et jouaient au croquet. Waouh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tout était collet monté, vieux et simplement… Pourquoi rien n’avait-il été rénové ? Pourquoi est-ce que tout était si vieux ? Cet homme, Nathanson, était censé être passionné par l’hôtel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hé, dit-il en arrêtant un homme en uniforme qui passait. Que se passe-t-il avec la fuite ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pardon, dit celui-ci en lui adressant un regard vide.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Désolé. Je suis le petit-fils de monsieur Patrick. Je me suis promené. Que s’est-il passé là-bas ? demanda-t-il en traînant le jeune et pointant le problème du doigt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il y avait un tuyau cassé qui devait être réparé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais pourquoi est-il encore évident que ce n’est pas fait ? Est-ce que le directeur ne fait pas son travail ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cullen savait qu’il se comportait comme un crétin, mais il était un peu énervé par la façon dont Nathanson venait de le congédier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je m’en occupe, Peter, dit une femme plus âgée en s’avançant, la main tendue. Yvonne, ravie de vous rencontrer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Enchanté de vous rencontrer, répondit Cullen en jetant un coup d’œil à son badge en essayant d’être discret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("C’était écrit : "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ventes de groupe.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cullen Patrick.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Êtes-vous Cullen ou Monsieur Patrick ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cullen, c’est sûr.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Personne ne l’avait jamais appelé monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cullen, faisons un petit tour et discutons.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Que s’est-il passé avec la fuite ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Monsieur Nathanson l’a fait réparer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais pas le plafond ? C’est l’apparence, je m’en rends compte, mais ces choses rendent l’endroit triste.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il a réparé le plafond du mieux qu’il l’a pu avec nos limites de l’époque. Le travail du plâtre est une affaire si délicate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La moquette ? dit-il en agitant la main vers celle effilochée des escaliers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Eh bien, oui, répondit-elle en souriant faiblement. Les tapis ici sont un motif personnalisé créé seulement pour nous par une filature dans les Carolines. Il faut du temps et de l’argent pour les remplacer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Alors quoi ? Il ne fait que l’amasser ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Amasser quoi ? dit-elle avec l’air totalement confus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— L’argent de mon grand-père ! s’exclama Cullen en agitant une main. Le vieil homme était plein aux as. Pourquoi l’argent ne revient-il pas à l’hôtel ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est le cas maintenant, répondit-elle sur un ton poli, mais pas le plus chaleureux du monde.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qu’est-ce que ça veut dire ? demanda Cullen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il la fixa et attendit. Il pouvait faire froid et concis aussi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela veut dire que le fidéicommis a été créé après le décès de monsieur Patrick. Jusque-là, c’était lui qui décidait du budget des réparations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Attendez, vous voulez dire que mon grand-père était un vieil avare ? Mon père disait toujours que cet hôtel était toute sa vie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je veux dire que monsieur Patrick était très malade et qu’il avait des difficultés cognitives.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hum, dit-il, réfléchissant à cela. Et Nathanson ? C’est un bon patron ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Matt est un directeur exceptionnel, juste et raisonnable. Je travaillerais pour lui n’importe où.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Waouh. Il était sûr qu’elle pensait cela aussi. Ouch, personne ne voulait entendre dire qu’un membre de sa famille était cinglé à la fin de sa vie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci, désolé de vous avoir contrariée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il s’excuserait auprès du voiturier après.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas du tout. Je vais vous faire visiter, si vous le souhaitez.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’apprécie. Ventes de groupe, alors ? Si je voulais réserver des chambres pour un groupe de snowboardeurs en tournée, ce serait avec vous, donc ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce serait totalement moi. Venez, je vais vous montrer la salle de bal. Elle va être spectaculaire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Est-ce que ça fait partie de la rénovation ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela fait partie de la première étape, répondit-elle. Les salles du premier étage, les principales zones communes et la salle de bal seront faites dans un mois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il fait beaucoup de travail, n’est-ce pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, affirma-t-elle")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle le ramena au rez-de-chaussée, puis vers une série d’immenses doubles portes dans le hall d’entrée")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La salle de bal était en désordre, mais il pouvait le travail en cours, apercevoir les bases exceptionnelles. L’endroit exprimait une sorte de décadence de l’âge d’or qui avait besoin d’être ravivé, mais, merde, ce serait génial lorsque ce serait fait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les gens pourront faire tant de choses dans cette pièce. Comme des mariages ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mariages, fêtes. Je pense que nous devrions avoir un bal d’Halloween fabuleux, l’année prochaine. Un bal masqué !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ça semble génial.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle semblait si enthousiaste et Cullen, venant du monde du sport, avait l’habitude d’encourager les gens.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— N’est-ce pas ? Il y a tant de membres du comité historique qui veulent que cet endroit retrouve sa gloire d’antan.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je m’en doute.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cullen se sentait complètement perplexe. Toutes les histoires de sa jeunesse indiquaient que son grand-père aimait l’hôtel plus que son fils. Pourquoi n’aurait-il pas dépensé son argent pour le garder en bon état ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ne comprenait pas. Il soupçonnait qu’il n’obtiendrait pas beaucoup d’informations de Nathanson non plus. Cet homme était un poisson froid. Comme le thon sur la glace. Plus boutonné qu’un cholo.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cullen renifla à cette dernière pensée. Il devrait s’en souvenir lorsqu’il irait à Los Angeles faire du skateboard avec son copain Easy au printemps prochain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Parlez-moi de ce truc de société historique.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Peut-être que quelqu’un là-bas aurait une idée de ce qui se passait vraiment ici. Quelqu’un qui n’était pas employé de l’hôtel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Le bâtiment est enregistré et les membres du comité ont de nombreuses opinions sur les idées de rénovation de Matt. Il a été très patient avec eux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vraiment ? Je n’ai pas eu l’impression qu’il était, euh, du genre à attendre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nathanson avait plus l’air de tout balayer d’un geste de la main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé ? Je ne vous suis pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Eh bien, il ne m’a pas semblé du genre à écouter des commentaires, expliqua Cullen en haussant les épaules. D’accord, je ne l’ai rencontré que pendant une minute, mais il m’a dit clairement qu’il n’avait pas le temps de discuter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il est incroyablement occupé. Il a essayé si durement de restaurer l’hôtel et… eh bien, personne ne vous attendait. Il ne restait plus que quelques jours avant que la propriété de l’hôtel ne lui soit transférée. Je suis sûre que c’est un choc de passer de propriétaire à employé en quelques minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il n’a jamais été le propriétaire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non. Non, je suppose qu’il ne l’était pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il pouvait dire qu’elle commençait à être mal à l’aise, mais il ne pouvait pas laisser tomber. Qu’est-ce que cela signifiait, juste quelques jours avant le transfert ? "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Note mentale : appelez ce satané avocat.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La dernière chose dont il avait besoin, c’était un employé qu’il ne pouvait pas virer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cullen retint le reste de ses opinions pendant la visite, mais au moment où il était prêt à retrouver Nathanson pour le dîner, il était remonté avec un tas de merdes qu’il voulait assener à l’homme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se dirigea vers le hall, ne sachant pas exactement où il devait retrouver monsieur coincé du cul.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bon sang, il n’était pas comme ça. Cullen s’enorgueillissait de sa facilité à vivre, de sa capacité à se débarrasser du stress. La vie était trop courte pour être son grand-père, n’est-ce pas ? "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Secoue ça, mec")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Monsieur Patrick ? demanda une femme âgée rondelette, s’approchant de lui, tout sourire. Matt s’occupe d’un problème de plomberie et m’a demandé de vous trouver et de m’assurer qu’on vous sert un bon dîner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il ne vient pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’homme ne savait-il pas déléguer ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je crois que ses mots exacts étaient, dites-lui que je serais heureux de le voir, mais je suis jusqu’au cou dans les emmerdes et au milieu d’un merdier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Un merdier, hein ? répéta Cullen en clignant des yeux. Ça sonne moins bien que le dîner. J’opterai pour la nourriture.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— En effet. Le chef a dit qu’il avait préparé une délicieuse omelette pour vous. Préférez-vous être servi dans votre chambre ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui. Je pense qu’il est temps d’aller lécher les proverbiales blessures.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle haussa les sourcils, mais il fit demi-tour et se dirigea vers sa chambre. Peut-être devrait-il appeler… euh, le chauffeur. Il pourrait retourner à Basalt. Cependant, encore une fois, cela ressemblerait à une fuite et il n’était pas un lâche. Il était en colère, bien sûr, mais il n’avait pas peur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La nourriture arriva quelques minutes plus tard et il dut admettre que c’était copieux et vraiment délicieux. Il ne s’attendait pas à ce que l’omelette soit aussi bonne, mais cela ressemblait aux omelettes qu’on lui avait servies en Italie. Prosciutto et fromage salé avec une salade croustillante à part.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Miam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il mangea tout, puis se laissa tenter par le merveilleux croissant qui l’accompagnait. Il sortirait demain et courrait quelques kilomètres. Ou, bon sang, il chercherait le centre de fitness ici. S’il voulait que la tournée s’installe ici, il fallait qu’il soit à la pointe de la technologie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ne serait-ce pas génial ? Faire venir tous ses potes ici ? Ils adoreraient ça. Ils aimeraient encore plus s’il y avait des cabines privées avec des jacuzzis. Hmm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il devrait peut-être s’impliquer un peu. Il pouvait faire de cet endroit ce qu’il voulait et laisser le côté historique intact. Il y avait beaucoup de terrain, n’est-ce pas ? Peut-être voir s’il était possible d’aménager un Snow Park.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Un endroit pour s’entraîner, un endroit amusant et jeune et non pas… indigeste.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il sourit et souleva le dernier couvercle du plateau pour trouver un morceau de gâteau aux carottes d’un kilomètre de haut. Il gémit. D’accord, il courrait beaucoup de kilomètres. Cela valait le coup.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La seule façon que ce fût meilleur serait que quelqu’un soit là pour le partager. Quelqu’un de nu et désireux. Merde, il était excité. Le gâteau aux carottes ne devrait pas être un aphrodisiaque, mais il mangeait si rarement des sucreries… Peut-être qu’il le garderait pour, genre trois heures du matin, lorsqu’il était si seul qu’il ne pouvait pas le supporter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("C’était pour ça qu’il louait habituellement un appartement ou un chalet avec un groupe d’hommes. Il y avait toujours du bruit ou quelqu’un.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pas cette horrible… tristesse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il reposa le dôme et se dirigea vers le canapé en face du lit. Il alluma la télévision, les rires joyeux d’une sitcom atténuant l’énorme bruit dans sa tête. Il était un athlète professionnel pour une raison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il détestait être seul.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 75
// module chunks = 0